import { useTranslation } from 'react-i18next'

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import useMobileMediaQuery from '@/hooks/useMobileMediaQuery'

const DEFAULT_BEHAVIOR_KEYS = [
  'threats',
  'violence',
  'weapon',
  'harassment',
  'prejudice',
  'disparaging',
  'selfHarm',
  'suggestiveContent',
  'fraud',
  'profanity',
  'polarizingContent',
  'drugs',
  'nudity',
  'alcohol',
] as const

interface BehaviorDetectionGuideSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const BehaviorDetectionGuideSheet = ({
  open,
  onOpenChange,
}: BehaviorDetectionGuideSheetProps) => {
  const { t } = useTranslation()
  const isMobile = useMobileMediaQuery()

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side={isMobile ? 'bottom' : 'right'}
        className="flex flex-col gap-4 max-md:h-[85vh] max-md:rounded-t-2xl sm:max-w-md"
      >
        <SheetHeader className="text-center sm:text-center">
          <SheetTitle>
            {t('dashboard.runReport.behaviorFlags.behaviorDetectionGuide')}
          </SheetTitle>
          <SheetDescription>
            {t(
              'dashboard.runReport.behaviorFlags.behaviorDetectionGuideSheetDescription',
            )}
          </SheetDescription>
        </SheetHeader>

        <div className="flex flex-1 min-h-0 flex-col gap-5 overflow-y-auto">
          {DEFAULT_BEHAVIOR_KEYS.map((key) => (
            <div key={key} className="flex flex-col gap-1">
              <p className="text-base font-medium text-neutralColor">
                {t(`dashboard.newSearch.focusedTopics.${key}`)}
              </p>
              <p className="text-sm text-neutralColor80">
                {t(`dashboard.newSearch.focusedTopics.${key}Description`)}
              </p>
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  )
}
